<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="test-task-server-table"
      class="w-100"
    >
      <span slot="order" slot-scope="{ row }">
        {{ row.order + 1 }}
      </span>
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/test-tasks/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>
      <span slot="instruments" slot-scope="{ row }">
        <span v-for="(instrument, index) in row.instruments" :key="index">
          <router-link :to="`/instrument/${instrument.id}`">
            {{ instrument.name }}
          </router-link>
          <template v-if="index !== row.instruments.length - 1">, </template>
        </span>
      </span>
      <span slot="analyses" slot-scope="{ row }">
        {{ formatAnalyses(row) }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit test task')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/test-tasks/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete test task')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ExistenceGate from "@/components/shared/ExistenceGate";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import TestTaskCollection from "@/collections/lab/TestTaskCollection";
import { mapActions, mapGetters } from "vuex";
import { ServerTable } from "vue-tables-2";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getEntityData, formatAnalyses } from "@/shared/utils";

Vue.use(ServerTable);

export default {
  name: "TestTaskServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    ModalTrashBasket,
    ServerTable,
  },
  props: {
    collection: {
      type: Object,
      default: () => new TestTaskCollection(),
    },
    show_columns: {
      type: Array,
      default: () => ["order", "name", "instruments", "analyses", "actions"],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["order", "name"],
    },
  },
  data() {
    const actions_access =
      this.checkPermission("edit test task") ||
      this.checkPermission("delete test task");

    return {
      entity_type: "testTask",
      test_process_id: this.$route.params.test_process_id || null,
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      trash: "testTaskTrash",
    }),
    show_modal() {
      return (
        this.checkPermission("delete test task") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    },
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    formatAnalyses(test_task) {
      return formatAnalyses(test_task);
    },
    prepareCollectionFilter(filter) {
      this.test_process_id &&
        filter.filterEquals("test_process_id", this.test_process_id);
      const connections = ["analyses.analyte", "instruments"];

      connections.forEach((connection) => {
        filter.connectionAdd(connection);
      });

      return filter;
    },
  },
};
</script>
